import React from "react";
import Lottie from "lottie-react";
import animationData from "./imageLoader.json";

const ImageLoader = ({ width, height }) => {
    return (
        <div
            style={{ width, height }}
            className="flex items-center justify-center overflow-hidden"
        >
            <Lottie
                animationData={animationData}
                loop={true}
                style={{ width, height }}
            />
        </div>
    );
};

export default ImageLoader;
